'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import RadialProgressBar from '../RadialProgressBar';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import ResultSection from './ResultSection';

var RadialResultSection = /*#__PURE__*/function (_React$Component) {
  _inherits(RadialResultSection, _React$Component);

  function RadialResultSection() {
    _classCallCheck(this, RadialResultSection);

    return _possibleConstructorReturn(this, _getPrototypeOf(RadialResultSection).apply(this, arguments));
  }

  _createClass(RadialResultSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          displayValueUnit = _this$props.displayValueUnit,
          displayValue = _this$props.displayValue,
          radialContainerClass = _this$props.radialContainerClass,
          score = _this$props.score,
          progressBarIcon = _this$props.progressBarIcon,
          gradeType = _this$props.gradeType;
      return /*#__PURE__*/_jsxs(ResultSection, {
        gradeType: gradeType,
        children: [/*#__PURE__*/_jsx(ResultHeader, Object.assign({}, this.props)), /*#__PURE__*/_jsxs("div", {
          className: radialContainerClass,
          children: [/*#__PURE__*/_jsx(RadialProgressBar, {
            score: score,
            children: /*#__PURE__*/_jsx("div", {
              className: "icon " + progressBarIcon
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "result-value",
            children: [displayValue, /*#__PURE__*/_jsx("span", {
              className: "result-value-unit",
              children: displayValueUnit
            })]
          })]
        }), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, this.props))]
      });
    }
  }]);

  return RadialResultSection;
}(React.Component);

RadialResultSection.propTypes = {
  gradeType: PropTypes.string,
  resultGrade: PropTypes.number,
  resultValueUnit: PropTypes.string,
  score: PropTypes.number,
  displayValueUnit: PropTypes.string,
  displayValue: PropTypes.number,
  radialContainerClass: PropTypes.object,
  progressBarIcon: PropTypes.string
};
export { RadialResultSection as default };